import React, { createContext, useContext, useEffect, useState } from 'react'

type Theme = 'light' | 'dark'

interface ThemeContextProps {
  theme: Theme
  setTheme: (theme: Theme) => void
}

const ThemeContext = createContext<ThemeContextProps>({
  theme: 'dark',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setTheme: () => {},
})

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const savedTheme = (localStorage.getItem('data-theme') as Theme) || ('dark' as Theme)
  const [theme, setThemeState] = useState<Theme>(savedTheme)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const queryTheme = params.get('theme') as Theme | null
    if (queryTheme === 'light' || queryTheme === 'dark') {
      setThemeState(queryTheme)
    }
  }, [])

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    localStorage.setItem('data-theme', theme)
  }, [theme])

  return (
    <ThemeContext.Provider value={{ theme, setTheme: setThemeState }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeContext)
